/* eslint-disable react/prop-types */
import * as React from 'react';
import classes from './PolicyPanel.module.css';

export const PolicyPanel = React.memo((props) => {
  const { icon, title, children } = props;

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        {!icon ? null : <img src={icon} alt="" className={classes.icon} />}
        <div className={classes.title}>{title}</div>
      </div>
      {children}
    </div>
  );
});
